/**
 * QR Scanner Component
 * 
 * Displays a camera-based QR code scanner for ticket redemption.
 * Falls back to manual entry if camera is not available.
 */
import { Scanner } from '@yudiel/react-qr-scanner';
import { useState } from 'react';

interface QRScannerProps {
  onScan: (code: string) => void;
  onError?: (error: string) => void;
}

export function QRScanner({ onScan, onError }: QRScannerProps) {
  const [hasPermission, setHasPermission] = useState(true);

  return (
    <div className="relative">
      {hasPermission ? (
        <Scanner
          onScan={(result) => {
            if (result?.[0]?.rawValue) {
              onScan(result[0].rawValue);
            }
          }}
          onError={(error) => {
            console.error('QR Scanner error:', error);
            setHasPermission(false);
            onError?.('Camera access denied or not available');
          }}
          constraints={{
            facingMode: 'user'
          }}
          styles={{
            container: { width: '100%', maxWidth: '400px', margin: '0 auto' },
            video: { borderRadius: '12px' }
          }}
        />
      ) : (
        <div className="text-center p-8 bg-gray-100 rounded-xl">
          <p className="text-gray-600 mb-2">Camera not available</p>
          <p className="text-sm text-gray-500">Please enter ticket code manually below</p>
        </div>
      )}
    </div>
  );
}
